import { LoadState } from "../../constants/enums";
import {
  IFeeRecord,
  IFeeTransition,
  IStudent,
  IStudentState,
} from "./student.types";

// export const initialCustomerState: ICustomer = {
//   personalInformation: {
//     data: {
//       customer_personal_information_id: 0,
//       customer_id: 0,
//       salutation: "",
//       first_name: "",
//       last_name: "",
//       goes_by: "",
//       position: "",
//       mobile: "",
//       phone: "",
//       phone_ext: "",
//       email: "",
//       status: "ACTIVE",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerProspect: {
//     data: {
//       customer_prospect_details_id: 0,
//       customer_id: 0,
//       customer_name: "",
//       csr: "",
//       customer_code: "",
//       form_of_business: "",
//       tax_zone: "ON",
//       mailing_address: "",
//       language: "E",
//       producer: "",
//       marketer: "",
//       branch: "",
//       assigned_to: null,
//       status: "ACTIVE",
//       insert_ts: "",
//       city: "",
//       province_or_state: "",
//       country: "",
//       postal_code: "",
//       unit_or_suite: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerSocial: {
//     data: {
//       customer_social_id: 0,
//       customer_id: 0,
//       website: "",
//       facebook: "",
//       linkedin: "",
//       status: "ACTIVE",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerRelatedAccount: {
//     data: {
//       customer_related_account_id: "",
//       customer_id: "",
//       cross_reference_id: "",
//       status: "ACTIVE",
//       name: "",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerConsent: {
//     data: {
//       incremental_number: 0,
//       customer_id: "",
//       privacy_consent: "",
//       privacy_act_consent: "",
//       anti_spam_consent: "",
//       telematics_consent_code: "",
//       status: "ACTIVE",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   opportunity: {
//     data: [],
//     totalRecords: 0,
//     loading: LoadState.NotLoaded,
//   },
//   customerConsentList: {
//     data: [],
//     loading: LoadState.NotLoaded,
//   },
//   customerGroupsList: {
//     data: [],
//     loading: LoadState.NotLoaded,
//   },
//   customerFullDetails: {
//     loading: LoadState.NotLoaded,
//   },
//   customerContacts: {
//     data: [],
//     loading: LoadState.NotLoaded,
//   },

//   error: "",
// };

export const defaultFeeTransaction: IFeeTransition = {
  fee_transaction_id: 0,
  fee_transaction_unique_id: 0,
  fee_transaction_uuid: "",
  opportunity_uuid: "",
  customer_fact_uuid: "",
  fee_type: "",
  customer_name: "",
  fees_paid: "",
  remarks: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  academic_year: "",
  batch: "",
  courses_name: "",
  courses_uuid: "",
  fee_structure_uuid: "",
  organizations_name: "",
  organizations_uuid: "",
  payment_mode: "",
  customer_code: null,
};

export const defaultStudent: IStudent = {
  aadhar_no: "",
  alternate_contact_no: "",
  annual_income: "",
  course_duration: "",
  batch: "",
  academic_year: 0,
  caste_category: "",
  city: "",
  contact_no: "",
  country: "",
  opportunity_uuid: "",
  course_fee_structure: "",
  courses_duration: null,
  courses_name: "",
  courses_uuid: "",
  create_ts: "",
  created_by_name: "",
  created_by_uuid: "",
  customer_code: "",
  customer_fact_uuid: "",
  docs_upload: "",
  customer_name: "",
  customer_personal_information_id: 0,
  customer_personal_information_unique_id: 0,
  date_of_birth: "",
  email_id: "",
  father_name: "",
  fathers_occupation: "",
  followUp_date_and_remark: "",
  gap_year: null,
  gender: "",
  session_uuid: "",
  hostel_required: "",
  inquiry_date: "",
  inquiry_reference: "",
  insert_ts: "",
  modified_by_name: "",
  modified_by_uuid: "",
  mother_name: "",
  mothers_occupation: "",
  organizations_name: "",
  organizations_uuid: "",
  parents_contact_no: "",
  permanent_address: "",
  pincode: 0,
  qualifications: [],
  remarks: "",
  seat_confirmation_fee: "",
  state: "",
  status: "",
  total_fee_amount: "",
  fees_paid: "",
  pending_fee: "",
  fee_type: "",
  fee_description: "",
};
export const defaultFeeRecord: IFeeRecord = {
  fees_paid: "",
  total_fees: "",
  fine_amount: "",
};

export const defaultStudentState: IStudentState = {
  list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  student: {
    data: defaultStudent,
    loading: LoadState.NotLoaded,
    error: null,
  },
  feeTransitionlist: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  feeTransition: {
    data: defaultFeeTransaction,
    loading: LoadState.NotLoaded,
    error: null,
  },
  feeRecord: {
    data: defaultFeeRecord,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
